import { Construction, type LucideIcon } from "lucide-react"

interface PlaceholderPageProps {
  icon?: LucideIcon
  title: string
  description?: string
}

export function PlaceholderPage({
  icon: Icon = Construction,
  title,
  description,
}: PlaceholderPageProps) {
  return (
    <div className="flex flex-col items-center justify-center rounded-lg border border-dashed border-border py-20">
      <div
        className="mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-blue-500/[0.08]"
      >
        <Icon size={28} className="text-primary opacity-60" />
      </div>
      <h2 className="text-lg font-semibold text-foreground">{title}</h2>
      <p className="mt-1.5 max-w-sm text-center text-sm text-muted-foreground">
        {description || "Ta sekcja jest w trakcie budowy. Wkr\u00F3tce b\u0119dzie dost\u0119pna."}
      </p>
      <span className="mt-4 inline-flex items-center gap-1.5 rounded-full border border-border bg-muted px-3 py-1 text-xs font-medium text-muted-foreground">
        <Construction size={12} />
        Wkr\u00F3tce
      </span>
    </div>
  )
}
